import React from 'react';
import { DivEditable } from '../../../library/components/base'; 
import { MDCFormCheckbox,MDCTextInput} from "../../../library/components/mdc-components";
import ServiceFactory from '../../../library/service/factory';

class NotificationBar extends React.Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {

    }

    get content() {
        return this.bar.text;
    }

    render() {
        var model = this.props.model;
        return (
            <div className="layout-notification-bar relative">
                <DivEditable cls="message" content={model.message} ref={(ref) => this.bar = ref} />
                <div className="action">
                    <a>LEARN MORE</a>
                </div>
                <div className="clear-button">
                    <i className="material-icons notification-bar-clear-icon">clear</i>
                </div>
            </div>
        );
    }
}




export class NotificationBarManage extends React.Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        this.Service = ServiceFactory.getType('NotificationAlert');
        setTimeout(() => {
            this.toast = document.querySelector('paper-toast');
        }, 1000);

    }

    onClick(event) {
        var data = this.props.data;
        var message = this.bar.content;
        var active = this.checkbox.checked;
        //console.log(this.checkbox.checked);
        //console.log(this.checkbox2.checked);
        var testActive=this.checkbox2.checked;
        if ((!message || message === '') && active) {
            this.toast.show("Error: Notification Message Required");
        } else {
            var entity = {
                id: 1,
                message: message,
                link: this.link.value,
                active: active,
                version: data.version,
                updatedAt: data.updatedAt,
                updatedAtString: data.updatedAtString,
                author: data.author,
                testMode:testActive
            };
            var service = new this.Service();
            service.post(entity, (err, data) => {
                if (!err) {
                    this.toast.show('Notification Bar Successfully Updated.')
                } else {
                    this.toast.show('Error: Notification Bar Update Failed.');
                }
            });
        }
    }

    render() {
        var checked = this.props.data.active;
        var checked2=this.props.data.testMode;
        var link = this.props.data.link;
        if(!link)link='';
        return (
            <div>
                <br />
                <NotificationBar ref={(ref) => this.bar = ref} model={this.props.data} />
                <br />
                <h4>Set Button Link <span className="admin-bar-small-info">(setting this value will display the LEARN MORE link)</span></h4>
                <div className="form-width">
                    <MDCTextInput cls="no-box-shadow-focus" placeholder="Button Link" ref={(ref) => this.link = ref} value={link} />
                </div>
                <h4 className="margin-top">Activate/Deactivate</h4>
                <MDCFormCheckbox label="Active" checked={checked} ref={(ref) => this.checkbox = ref}  />
                <br />
                <h4 className="margin-top">Test Mode <span className="admin-bar-small-info">(TEST/DEVELOPENT mode will always display for Administrators only)</span></h4>
                <MDCFormCheckbox label="Test Mode" checked={checked2} ref={(ref) => this.checkbox2 = ref} />
                <br />
                <h4 className="margin-top"><i className="material-icons">publish</i> Publish Notification </h4>
                <button className="ui-button primary large" onClick={this.onClick.bind(this)}>Publish</button>
                <br /><br />
            </div>
        );
    }
}


export default {NotificationBarManage}